// src/lib/sessionUser.js
// Schneller Ersatz für supabase.auth.getUser():
// liest den eingeloggten User aus der lokal gespeicherten Sitzung statt jedes Mal
// beim Supabase-Server nachzufragen. Supabase arbeitet getUser-Aufrufe nacheinander ab,
// bei vielen gleichzeitigen Aufrufen (z. B. im Hauptmenü) summiert sich das spürbar.
// Gleiche Rückgabeform wie getUser: { data: { user }, error }.
// Die Datenbank prüft das Login-Token ohnehin selbst (Row Level Security).

import { supabase } from "../supabaseClient";

export async function getSessionUser() {
  const { data, error } = await supabase.auth.getSession();
  return { data: { user: data?.session?.user ?? null }, error };
}
